import { useAzureAuthScreenRedirect } from '../../context/AzureAuth';

export const LoginScreen = () => {
  useAzureAuthScreenRedirect();

  return null;
};
